// src\themes\lino\components\Marquee.tsx
import Image from 'next/image';

type MarqueeItem = {
    title?: string;
    image?: {
        url: string;
        description?: string;
    };
};

type MarqueeData = {
    items?: MarqueeItem[];
    direction?: 'left' | 'right';
    speed?: 'slow' | 'normal' | 'fast';
};

const SPEED_MAP: Record<string, string> = {
    slow: '42s',
    normal: '28s',
    fast: '16s',
};

export default function Marquee({ data }: { data: MarqueeData }) {
    // هر آیتم می‌تونه لوگو/تصویر باشه (image) یا متن (title)؛ اگه تصویر پر باشه
    // همیشه اولویت با تصویره و متن نمایش داده نمی‌شه.
    const items = data.items?.filter(i => i.title?.trim() || i.image?.url) || [];
    if (!items.length) return null;

    const duration = SPEED_MAP[data.speed || 'normal'];
    const reverse = data.direction === 'right';

    return (
        <div className="col-span-12 border-y border-primary-900 py-7 select-none overflow-hidden">
            <div
                className="flex w-max animate-lino-marquee"
                style={{
                    animationDuration: duration,
                    animationDirection: reverse ? 'reverse' : 'normal',
                }}
            >
                {[0, 1].map(dup => (
                    <div key={dup} className="flex items-center shrink-0">
                        {items.map((item, i) => (
                            <span key={i} className="flex items-center shrink-0">
                                {item.image?.url ? (
                                    <Image
                                        src={item.image.url}
                                        alt={item.image.description || item.title || 'logo'}
                                        width={120}
                                        height={40}
                                        className="h-7 lg:h-9 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity"
                                    />
                                ) : (
                                    <span className="text-sm lg:text-base font-normal text-primary-700 tracking-wide whitespace-nowrap">
                                        {item.title}
                                    </span>
                                )}
                                <span className="mx-8 text-primary-300">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}